var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.177 10.059h-3.294a.823.823 0 0 0-.824.824v.823c-3.294 0-5.713-2.522-5.765-5.764h.823a.824.824 0 0 0 .825-.824V1.824A.824.824 0 0 0 5.117 1H1.823A.824.824 0 0 0 1 1.824v4.118A9.058 9.058 0 0 0 10.059 15h4.118a.822.822 0 0 0 .823-.823v-3.294a.823.823 0 0 0-.823-.824"}));
}

Phone.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Phone;

Phone.default = Phone;
